import { ISingleColumnDynamicForm } from './SingleColumnDynamicForm';

export const singleColumnDynamicFormTransformer = (
    node
): ISingleColumnDynamicForm => {
    return {
        theme: node.field_theme,
        formHeadingData: {
            formHeadingText:
                node.relationships?.field_dynamic_form_column?.field_heading ??
                undefined,
            formHeadingTag:
                node.relationships?.field_dynamic_form_column
                    ?.field_heading_tag_select,
            formHeadingSubtitle:
                node.relationships?.field_dynamic_form_column?.field_subtitle,
            align: node.relationships?.field_dynamic_form_column?.field_lc_align?.toLowerCase(),
            static: node.relationships?.field_dynamic_form_column
                ?.field_toggle_static,
        },
        id: node.relationships?.field_dynamic_form_column?.relationships
            ?.field_form?.id,
        formElements:
            node.relationships?.field_dynamic_form_column?.relationships
                ?.field_form?.elements,
        submissionUrl:
            node.relationships?.field_dynamic_form_column?.relationships
                ?.field_form?.handlers?.remote_post?.settings?.completed_url ||
            ``,
        formDisclaimer:
            node.relationships?.field_dynamic_form_column?.field_disclaimer
                ?.value,
        successPageUrl:
            node.relationships?.field_dynamic_form_column
                ?.field_success_page_url,
    };
};
